import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IDatasourceUsageInfo } from '../../../ts/ServerApi/types/IUsageInfo';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem, ITypedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IDataSource } from '../types/IDataSource';

export interface IGetDatasourcesParams extends IGetItemsParams {
}

export interface IGetDatasourcesResult extends IGetItemsResult {
  datasources?: IDataSource[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IDatasourceUsageInfo;
  favorites?: string[];
  workbooks?: INamedItem[];
}

export class GetDatasourcesRequest extends Request<IGetDatasourcesParams, IGetDatasourcesResult> {
  constructor(params: IGetDatasourcesParams) {
    super('getDatasources', params);
  }
}
